function getKeyByValue(value, Enum) {
  let indexOfS = Object.values(Enum).indexOf(Number(value));
  return Object.keys(Enum)[indexOfS].replace(/_/g, " ");
}

export { getKeyByValue };
